export type ColumnDefinition = {
  field: string;
  header: string;
  sortable?: boolean;
  headerClassName?: string;
  bodyClassName?: string;
};

export type DataTableProps<T> = {
  columns: ColumnDefinition[];
  value: T[];
  loading?: boolean;
  withPaginator?: boolean;
  listlimit?: number;
  currentPage?: number;
  countTotal?: number;
  limitHandler?: (limit: number) => void;
  currentPageHandler?: (page: number) => void;
};

export type Option = {
  label: string;
  value: string;
};

export const dropdownOptions = [
  { label: 10, value: 10 },
  { label: 30, value: 30 },
  { label: 50, value: 50 },
  { label: 120, value: 120 },
];
